import React, { useEffect, useState } from 'react';
import {
    Box,
    Container,
    Typography,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    TablePagination
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { getAllEnqueries, exportEnqueries } from '../Apis/EnqueryApis';

const Enqueries = () => {
    const [enqueries, setEnqueries] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // Pagination State
    const [page, setPage] = useState(0); // MUI Pagination is 0-indexed
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalCount, setTotalCount] = useState(0);

    const fetchEnqueries = async (currentPage, limit) => {
        setIsLoading(true);
        try {
            // API expects 1-indexed page
            const response = await getAllEnqueries(currentPage + 1, limit);
            if (response.data && response.data.status) {
                setEnqueries(response.data.data || []);
                setTotalCount(response.data.pagination?.totalItems || 0);
            }
        } catch (error) {
            console.error("Error fetching enqueries:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchEnqueries(page, rowsPerPage);
    }, [page, rowsPerPage]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleExport = async () => {
        try {
            const response = await exportEnqueries();
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `enquiries_${new Date().toLocaleDateString()}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            console.error("Error exporting enqueries:", error);
            alert("Failed to export enquiries. Please try again.");
        }
    };

    return (
        <Container maxWidth="xl" >
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                <Typography variant="h4" component="h1">
                    Enquiries
                </Typography>
                <Button
                    variant="contained"
                    color="success"
                    startIcon={<DownloadIcon />}
                    onClick={handleExport}
                >
                    Export to Excel
                </Button>
            </Box>

            {isLoading ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
                    <CircularProgress />
                </Box>
            ) : (
                <Paper sx={{ borderRadius: 2, boxShadow: '0 4px 6px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
                    <TableContainer>
                        <Table sx={{ minWidth: 650 }}>
                            <TableHead sx={{ bgcolor: '#f5f5f5' }}>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>ID</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Name</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Category</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Mobile</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Location</TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {enqueries.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
                                            No enqueries found
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    enqueries.map((enquery, index) => (
                                        <TableRow key={enquery.id} hover>
                                            <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                            <TableCell>{enquery.name || '-'}</TableCell>
                                            <TableCell>{enquery.Category?.name || '-'}</TableCell>
                                            <TableCell>{enquery.mobile || '-'}</TableCell>
                                            <TableCell>{enquery.location || '-'}</TableCell>
                                            <TableCell>
                                                {enquery.createdAt ? new Date(enquery.createdAt).toLocaleDateString() : '-'}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            )}
        </Container>
    );
};

export default Enqueries;
